import { useLocale } from '@ecomm/data-hooks'
import { useCallback } from 'react'
import { useTrackingDropdownMenu } from '../../../hooks/useTrackingDropdownMenu'
import { DesktopDropdownMenu } from '../DesktopDropdownMenu'
import type { HeaderRedesignSchema } from '../schema'
import { PackagesLinks } from './PackagesLinks'
import { PackagesMenuLeftItems } from './PackagesMenuLeftItems'
import { PackagesRightSide } from './PackagesRightSide'

type PackagesDropdownMenuProps = HeaderRedesignSchema & {
  readonly onToggleDropdown: (close?: boolean) => void
  readonly showDropdown: boolean
  // (sideNav === true) => This dropdown menu is being displayed in the side nav and not in desktop mode
  readonly sideNav: boolean
}
export function PackagesDropdownMenu({
  images,
  onToggleDropdown,
  showDropdown,
  sideNav
}: PackagesDropdownMenuProps) {
  const locale = useLocale()

  const trackingPackagesDropdownMenu = useTrackingDropdownMenu()
  const handleClick = useCallback(
    (text: string) => () => {
      onToggleDropdown(true)
      trackingPackagesDropdownMenu(text)
    },
    [onToggleDropdown, trackingPackagesDropdownMenu]
  )

  return (
    <DesktopDropdownMenu
      title="PackagesDropdownMenu"
      showDropdown={showDropdown}
      sideNav={sideNav}
      baseClassNames="left-0 top-full z-[2] flex w-full flex-wrap justify-start gap-3 bg-white px-0 min-[1126px]:absolute min-[1126px]:h-52 min-[1126px]:flex-nowrap min-[1126px]:justify-center min-[1126px]:py-4 min-[1126px]:shadow-md min-[1380px]:gap-8"
      dataTestId="packages-dropdown-menu"
    >
      <PackagesMenuLeftItems locale={locale} handleClick={handleClick} />
      <div className="hidden h-full w-px min-[1126px]:block" />
      <PackagesLinks
        locale={locale}
        images={images}
        handleClick={handleClick}
      />
      <div className="hidden h-full w-px border-0 border-r border-solid border-neutral-300 min-[1126px]:block" />
      <PackagesRightSide
        locale={locale}
        images={images}
        handleClick={handleClick}
      />
    </DesktopDropdownMenu>
  )
}
